<template lang="pug">
ticket-list(scope="system")
</template>

<script>
import TicketList from '@/extensions/tickets/views/TicketList';

export default {
    name: 'SystemTicketList',
    components: { TicketList },
};
</script>
